export const PATH = "/:context/simulado";
export const LAST_PATH = `${PATH}/anteriores`;
export const LAST_DETAILS_PATH = `${LAST_PATH}/:slug`;
export const DETAILS_PATH = `${PATH}/:slug`;
export const RANKING_PATH = `${PATH}/:slug/ranking`;
